import { render, staticRenderFns } from "./captions.vue?vue&type=template&id=163584ec&scoped=true&"
import script from "./captions.vue?vue&type=script&lang=js&"
export * from "./captions.vue?vue&type=script&lang=js&"
import style0 from "./captions.vue?vue&type=style&index=0&id=163584ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163584ec",
  null
  
)

export default component.exports